import React from 'react'
import StaticContent from '@components/StaticContent'
import cx from 'classnames'
import { adStyles } from './adStyles'

/**
 * 刊尾廣告
 *
 * Ad unit = `BT_a_F`
 */
export default function PostBottomAd(props) {
  return (
    <StaticContent
      style={{ overflow: 'visible' }}
      className={cx('Zi_ad_a_F', props.className)}
      css={adStyles}
    />
  )
}
